import React from "react";
import GridContainer from "./GridContainer";
import Button from "./Buttons";

const HeroSection = ({
    title,
    subtitle,
    subtitle2,
    subtitle3,
    subtitle4,
    button1Text,
    button1Link,
    onButton1Click,
    button2Text,
    onButton2Click,
    variant = "center"
}) => {
    const renderButton = () => {
        if (!button1Text) return null;

        return (
            <div className="mt-10 flex flex-wrap gap-4 justify-center">
                <Button
                    variant="green"
                    to={button1Link}
                    onClick={(e) => {
                        if (onButton1Click) {
                            e.preventDefault();
                            onButton1Click();
                        }
                    }}
                >
                    {button1Text}
                </Button>
                {button2Text && (
                    <Button
                        variant="white"
                        onClick={(e) => {
                            e.preventDefault();
                            if (onButton2Click) onButton2Click();
                        }}
                    >
                        {button2Text}
                    </Button>
                )}
            </div>
        );
    };

    if (variant === "left") {
        return (
            <section className="py-20">
                <GridContainer>
                    <div className="grid grid-cols-1 lg:grid-cols-12 text-left">
                        <div className="lg:col-start-1 lg:col-span-7">
                            <h1 className="text-holborn-blue mb-6 lg:mb-8">{title}</h1>
                        </div>
                        {subtitle && (
                            <div className="lg:col-start-1 lg:col-span-7">
                                <h4 className="text-holborn-blue mb-6 lg:mb-8">{subtitle}</h4>
                            </div>
                        )}
                        {button1Text && (
                            <div className="lg:col-start-1 lg:col-span-7">
                                {renderButton()}
                            </div>
                        )}
                    </div>
                </GridContainer>
            </section>
        );
    }

    return (
        <section className="py-20">
            <GridContainer>
                <div className="grid grid-cols-1 lg:grid-cols-12 text-center">
                    <div className="lg:col-start-3 lg:col-span-8">
                        <h1 className="text-holborn-blue mb-6 lg:mb-8">{title}</h1>
                    </div>
                    {subtitle && (
                        <div className="lg:col-start-3 lg:col-span-8">
                            <h4 className="text-holborn-blue mb-6 lg:mb-8">{subtitle}</h4>
                        </div>
                    )}
                    {subtitle2 && (
                        <div className="lg:col-start-3 lg:col-span-8 2xl:col-start-4 2xl:col-span-6">
                            <h5 className="text-holborn-mid-blue mb-4">
                                {subtitle2.replace(/\s+(\S+)$/, '\u00A0$1')}
                            </h5>
                        </div>
                    )}
                    {subtitle3 && (
                        <div className="lg:col-start-3 lg:col-span-8 2xl:col-start-4 2xl:col-span-6">
                            <p className=" mb-4">{subtitle3}</p>
                        </div>
                    )}
                    {subtitle4 && (
                        <div className="lg:col-start-3 lg:col-span-8 2xl:col-start-4 2xl:col-span-6">
                            <p className=" mb-4">{subtitle4}</p>
                        </div>
                    )}
                    {button1Text && (
                        <div className="lg:col-start-3 lg:col-span-8">
                            {renderButton()}
                        </div>
                    )}
                </div>
            </GridContainer>
        </section>
    );
};

export default HeroSection;